import React from 'react';
import PropTypes from 'prop-types';
import ModalConfirmation from '../ModalConfirmation';
import { handleConfirmSelect } from '../../../utils/handleConfirmSelect';

const ShortlistModals = ({
  // Shortlist
  showModal,
  handleCancelSelect,
  selectedCandidate,
  selectedNominationId,
  setShowModal,

  // Recommend to council
  showStage2Modal,
  handleCancelStage2Select,
  selectedStage2Candidate,
  selectedStage2NominationId,
  setShowStage2Modal,

  // Common
  refreshNominations,
  setRefreshNominations,
}) => (
  <>
    {/* Shortlisted Modal */}
    <ModalConfirmation
      showModal={showModal}
      handleCancelSelect={handleCancelSelect}
      bodyText={`Are you sure you want to **shortlist** ${selectedCandidate}?`}
      handleConfirmSelect={handleConfirmSelect}
      rowId={`${selectedNominationId}`}
      apiIdentifier="nomination-shortlist"
      refreshCollections={refreshNominations}
      setRefreshCollections={setRefreshNominations}
      setShowModal={setShowModal}
    />

    {/* Recommended to Council Modal */}
    <ModalConfirmation
      showModal={showStage2Modal}
      handleCancelSelect={handleCancelStage2Select}
      bodyText={`Are you sure you want to **shortlist for Council consideration** ${selectedStage2Candidate}?`}
      handleConfirmSelect={handleConfirmSelect}
      rowId={`${selectedStage2NominationId}`}
      apiIdentifier="nomination-shortlist-council"
      refreshCollections={refreshNominations}
      setRefreshCollections={setRefreshNominations}
      setShowModal={setShowStage2Modal}
    />
  </>
);

ShortlistModals.propTypes = {
  showModal: PropTypes.bool.isRequired,
  handleCancelSelect: PropTypes.func.isRequired,
  selectedCandidate: PropTypes.string,
  selectedNominationId: PropTypes.number,
  setShowModal: PropTypes.func.isRequired,
  showStage2Modal: PropTypes.bool.isRequired,
  handleCancelStage2Select: PropTypes.func.isRequired,
  selectedStage2Candidate: PropTypes.string,
  selectedStage2NominationId: PropTypes.number,
  setShowStage2Modal: PropTypes.func.isRequired,
  refreshNominations: PropTypes.bool.isRequired,
  setRefreshNominations: PropTypes.func.isRequired,
};

export default ShortlistModals;
